export enum OrderType {
  delivery = 'DELIVERY',
  return = 'RETURN'
}
